/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

import { defineComponent, PropType } from "vue";
import { IMenuItem } from ".";

export default defineComponent({
  props: {
    items: {
      type: Array as PropType<IMenuItem[]>,
      required: true
    },
    value: [String, Number]
  }
});